
enum AuthenticationResult {
    PENDING = "",
    SUCCESS = "success",
    INVALID_CREDENTIALS = "Invalid Username/Password Combination",
    TIMEOUT = "Validation Timed Out",
    RESET_PASSWORD_REQUIRED = "Reset Password Required"
}

export {AuthenticationResult}